import React from 'react';
import {
  AppBar, Toolbar, Typography, makeStyles, IconButton,
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { ExitToApp } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: 60,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const Header = (props) => {
  const classes = useStyles();

  const exit = () => {
    // eslint-disable-next-line react/prop-types
    props.history.push('/');
  };


  return (
    <AppBar>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          JBoleto
        </Typography>
        <IconButton color="inherit" onClick={exit}>
          <ExitToApp />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default withRouter(Header);
